import { render } from "./InformacionSolicitante.vue?vue&type=template&id=722dd566"
import script from "./InformacionSolicitante.vue?vue&type=script&lang=js"
export * from "./InformacionSolicitante.vue?vue&type=script&lang=js"

import "./InformacionSolicitante.vue?vue&type=style&index=0&id=722dd566&lang=css"
script.render = render

export default script